/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* Generated Angular service for UniteEnseignementResource controller
* Do not edit this file manually
*/
import { HttpClient, HttpContext, HttpContextToken, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BASE_PATH_FORMATIONAPI, CLIENT_CONTEXT_TOKEN_FORMATIONAPI } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { RequestOptions, UniteEnseignementViewDTO } from "../models";

@Injectable({ providedIn: "root" })
export class UniteEnseignementResourceService {
    private readonly httpClient: HttpClient = inject(HttpClient);
    private readonly basePath: string = inject(BASE_PATH_FORMATIONAPI);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_FORMATIONAPI;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'formationApi');
    }

    findUniteEnseignementEtablissement(idEtablissement?: number, observe?: 'body', options?: RequestOptions<'blob'>): Observable<Array<UniteEnseignementViewDTO>>;
    findUniteEnseignementEtablissement(idEtablissement?: number, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<Array<UniteEnseignementViewDTO>>>;
    findUniteEnseignementEtablissement(idEtablissement?: number, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<Array<UniteEnseignementViewDTO>>>;
    findUniteEnseignementEtablissement(idEtablissement?: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/unite-enseignement-etablissement`;

        let params = new HttpParams();
        if (idEtablissement != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idEtablissement, 'idEtablissement');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    findUniteEnseignementEtablissement1(idEtablissement?: number, observe?: 'body', options?: RequestOptions<'blob'>): Observable<Array<UniteEnseignementViewDTO>>;
    findUniteEnseignementEtablissement1(idEtablissement?: number, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<Array<UniteEnseignementViewDTO>>>;
    findUniteEnseignementEtablissement1(idEtablissement?: number, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<Array<UniteEnseignementViewDTO>>>;
    findUniteEnseignementEtablissement1(idEtablissement?: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/unite-enseignement-etablissement`;

        let params = new HttpParams();
        if (idEtablissement != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idEtablissement, 'idEtablissement');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('post', url, {
            body: null,
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    findUniteEnseignementEtablissement2(idEtablissement?: number, observe?: 'body', options?: RequestOptions<'blob'>): Observable<Array<UniteEnseignementViewDTO>>;
    findUniteEnseignementEtablissement2(idEtablissement?: number, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<Array<UniteEnseignementViewDTO>>>;
    findUniteEnseignementEtablissement2(idEtablissement?: number, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<Array<UniteEnseignementViewDTO>>>;
    findUniteEnseignementEtablissement2(idEtablissement?: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/unite-enseignement-etablissement`;

        let params = new HttpParams();
        if (idEtablissement != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idEtablissement, 'idEtablissement');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('put', url, {
            body: null,
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    findUniteEnseignementEtablissement4(idEtablissement?: number, observe?: 'body', options?: RequestOptions<'blob'>): Observable<Array<UniteEnseignementViewDTO>>;
    findUniteEnseignementEtablissement4(idEtablissement?: number, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<Array<UniteEnseignementViewDTO>>>;
    findUniteEnseignementEtablissement4(idEtablissement?: number, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<Array<UniteEnseignementViewDTO>>>;
    findUniteEnseignementEtablissement4(idEtablissement?: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/unite-enseignement-etablissement`;

        let params = new HttpParams();
        if (idEtablissement != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idEtablissement, 'idEtablissement');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('patch', url, {
            body: null,
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    findUniteEnseignementEtablissement3(idEtablissement?: number, observe?: 'body', options?: RequestOptions<'blob'>): Observable<Array<UniteEnseignementViewDTO>>;
    findUniteEnseignementEtablissement3(idEtablissement?: number, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<Array<UniteEnseignementViewDTO>>>;
    findUniteEnseignementEtablissement3(idEtablissement?: number, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<Array<UniteEnseignementViewDTO>>>;
    findUniteEnseignementEtablissement3(idEtablissement?: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/unite-enseignement-etablissement`;

        let params = new HttpParams();
        if (idEtablissement != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idEtablissement, 'idEtablissement');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('delete', url, {
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    findUniteEnseignementEtablissement6(idEtablissement?: number, observe?: 'body', options?: RequestOptions<'blob'>): Observable<Array<UniteEnseignementViewDTO>>;
    findUniteEnseignementEtablissement6(idEtablissement?: number, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<Array<UniteEnseignementViewDTO>>>;
    findUniteEnseignementEtablissement6(idEtablissement?: number, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<Array<UniteEnseignementViewDTO>>>;
    findUniteEnseignementEtablissement6(idEtablissement?: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/unite-enseignement-etablissement`;

        let params = new HttpParams();
        if (idEtablissement != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idEtablissement, 'idEtablissement');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('options', url, {
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    findUniteEnseignementEtablissement5(idEtablissement?: number, observe?: 'body', options?: RequestOptions<'blob'>): Observable<Array<UniteEnseignementViewDTO>>;
    findUniteEnseignementEtablissement5(idEtablissement?: number, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<Array<UniteEnseignementViewDTO>>>;
    findUniteEnseignementEtablissement5(idEtablissement?: number, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<Array<UniteEnseignementViewDTO>>>;
    findUniteEnseignementEtablissement5(idEtablissement?: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/unite-enseignement-etablissement`;

        let params = new HttpParams();
        if (idEtablissement != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idEtablissement, 'idEtablissement');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('head', url, {
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }
}
